var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurveyName(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 0.935181C8.68447 0.935181 8.8512 1.03677 8.93793 1.19489L8.97434 1.27845L10.6343 6.27856C10.6393 6.29174 10.6438 6.3052 10.6477 6.3189L11.8604 9.97162H12.5C12.7761 9.97162 13 10.1964 13 10.4736C13 10.7201 12.8231 10.9251 12.5899 10.9676L12.5 10.9757H11.5115C11.5038 10.9758 11.496 10.9758 11.4883 10.9757H9.5C9.22386 10.9757 9 10.7509 9 10.4736C9 10.2272 9.17688 10.0222 9.41012 9.97971L9.5 9.97162H10.8062L9.80602 6.95947H6.19355L5.19368 9.97162H6.5C6.77614 9.97162 7 10.1964 7 10.4736C7 10.7201 6.82312 10.9251 6.58988 10.9676L6.5 10.9757H4.51168C4.50396 10.9758 4.49622 10.9758 4.48846 10.9757H3.5C3.22386 10.9757 3 10.7509 3 10.4736C3 10.2272 3.17688 10.0222 3.41012 9.97971L3.5 9.97162H4.13962L5.35229 6.31889C5.35619 6.3052 5.36067 6.29175 5.36567 6.27856L7.02566 1.27845C7.08399 1.10274 7.2327 0.976049 7.40953 0.943438L7.5 0.935181H8.5ZM6.52684 5.95542H9.47262L8.139 1.93923H7.86L6.52684 5.95542Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 12.9838H15.5C15.7761 12.9838 16 13.2085 16 13.4858V16.4979C16 16.7752 15.7761 17 15.5 17H0.5C0.223858 17 0 16.7752 0 16.4979V13.4858C0 13.2085 0.223858 12.9838 0.5 12.9838ZM15 15.9959V13.9878H1V15.9959H15Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyName);
export default __webpack_public_path__ + "static/media/survey-name.692a770c7c5db92ed93ff888465ce844.svg";
export { ForwardRef as ReactComponent };